/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import moment from "moment";
import DashboardDateChecker from "../../components/DashboardDateChecker";
import PageToolbar from "../../components/PageToolbar";
import { Button, Card, Checkbox, Col, Form, Icon } from "antd";
import { Row } from "antd/es/grid";
import DateTimePicker from "../../components/DateTimePicker";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import GenericModal from "../../components/GenericModal";
import ResponsiveTable from "../../components/ResponsiveTable";
import ReportShowButton from "../../components/ReportShowButton";


class DynamicReceiptDisplay extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            _date: moment().format("YYYY-MM-DD"),
            _fromHour: '00:00:00',
            _toHour: '00:00:00',
            _branchList: '',
            _includePayItems: '1',
            _includeCreditDocs: '0',

            modalOpen: false,
            viewPerBranch: false,
            loading: false
        };

        this.id = "DYNAMIC_RECEIPT_DISPLAY";

        this.api = {
            get: "get_dynamic_receipt_display"
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { dataset: [], branchDataset: [], sumAll: 0, countAll: 0 };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.sendAPI("get_all_gp_by_user", "", ob => {
            if (ob.data) {
                ob.data.split("\r").forEach(x => {
                    let y = x.split("\f");
                    if (y[0] == 'GP_StartDayHour' && y[1] && y[1].length == 5) {
                        let _fromHour = y[1] + ":00"
                        let _toHour = moment("2020-01-02 " + _fromHour).add(-1, "second").format("HH:mm:ss")
                        this.setState({ _fromHour, _toHour })
                    }
                })
            }
        })
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21282);
    }

    apiTable = () => {
        this.setState({ loading: true }, () => {

            const { _date, _fromHour, _toHour, _branchList, _includePayItems, _includeCreditDocs } = this.state
            this.sendAPI(this.api.get, { _date, _fromHour, _toHour, _branchList, _includePayItems, _includeCreditDocs }, ob => {
                let dataset = [];
                let branchDataset = []
                let sumAll = 0;
                let countAll = 0;

                if (ob.data) {
                    ob.data.split("\r").map(x => {

                        let y = x.split("\f")

                        let _sectionId = y[0]
                        let _branchId = y[1]
                        let _branchName = y[2]
                        let _payId = y[3]
                        let _payName = y[4]
                        let _datetime = y[5]
                        let _docNum = y[6]
                        let _ref2 = y[7]
                        let _custName = y[8]
                        let _sum = parseFloat(y[9]) ? parseFloat(y[9]) : 0
                        let _count = parseFloat(y[10]) ? parseFloat(y[10]) : 0
                        let _typeName = y[11]
                        let _pos = y[12]
                        let _type = y[13]

                        sumAll += _sum;
                        countAll += _count;

                        let findPrimary = dataset.findIndex(f => f._sectionId == _sectionId && f._payId == _payId)
                        let findBranch = branchDataset.findIndex(f => f._sectionId == _sectionId && f._branchId == _branchId && f._payId == _payId)

                        if (findPrimary > -1) {
                            dataset[findPrimary] = {
                                ...dataset[findPrimary],
                                _sum: dataset[findPrimary]._sum + _sum,
                                _count: dataset[findPrimary]._count + _count,
                                detaild: [
                                    ...dataset[findPrimary].detaild,
                                    { _datetime, _docNum, _ref2, _custName, _sum, _typeName, _pos, _type }
                                ]
                            }
                        } else {
                            dataset = [
                                ...dataset,
                                {
                                    _sectionId, _payId, _payName, _sum, _count,
                                    detaild: [
                                        { _datetime, _docNum, _ref2, _custName, _sum, _typeName, _pos, _type }
                                    ]
                                }
                            ]
                        }

                        if (findBranch > -1) {
                            branchDataset[findBranch] = {
                                ...branchDataset[findBranch],
                                _sum: branchDataset[findBranch]._sum + _sum,
                                _count: branchDataset[findBranch]._count + _count,
                                detaild: [
                                    ...branchDataset[findBranch].detaild,
                                    { _datetime, _docNum, _ref2, _custName, _sum, _typeName, _pos, _type }
                                ]
                            }
                        } else {
                            branchDataset = [
                                ...branchDataset,
                                {
                                    _sectionId, _branchId, _branchName, _payId, _payName, _sum, _count,
                                    detaild: [
                                        { _datetime, _docNum, _ref2, _custName, _sum, _typeName, _pos, _type }
                                    ]
                                }
                            ]
                        }

                    })

                }

                this.setState({ modalOpen: true, loading: false }, () => {
                    this.props.dataActions.setJson(this.id, { dataset, branchDataset, sumAll, countAll })
                })
            })
        })
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }


    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",

            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };

        const hourField = (field) => {
            return (<DateTimePicker
                format="HH:mm"
                value={this.state[field]}
                onChange={e => { this.setState({ [field]: e }) }}
            />)
        }

        const render = t => t
        const renderDate = t => moment(t).format("DD/MM/YYYY")
        const renderTime = t => moment(t).format("HH:mm")
        const renderSum = t => t.toFixed(2)
        const renderPrimary = (t, r) => r.key == "sumRow" ? <b>{t}</b> : t
        const renderDetail = (t, r) => r.key == "sumRow" ? "" : (<Icon type={"table"} onClick={() => { this.setState({ modalDetail: r }) }} />)
        const renderDocView = (t, r) => r.key == "sumRow" ? "" : (<ReportShowButton
            {...this.props} iconButton validSubmit tooltip={this.getText(21247)} type={"file-pdf"}
            params={{
                DocumentNumber: r._docNum,
                DocumentTypeID: r._type,
                DocumentPOSID: r._pos,
                userID: this.props.user.userId,
                userName: encodeURIComponent(this.props.user.displayName),
                CompanyCode: this.props.user.companyCode,
                isOriginal: false,
                CentralFatherItem: 0,
                PrintFormat: null,
                docIsWithSigns: 0,
                reportName: "reports/DocumentCopy.pdf",
                REPORT_LOCALE: this.getText(101)
            }} />)
        const getDetaild = d => {
            return ((<ResponsiveTable
                tableOnly
                dataSource={d}
                columns={[
                    { title: gt(21290), key: "_date", dataIndex: "_datetime", width: "11%", render: renderDate },
                    { title: gt(21291), key: "_time", dataIndex: "_datetime", width: "11%", render: renderTime },
                    { title: gt(21292), key: "_docNum", dataIndex: "_docNum", width: "11%", render },
                    { title: gt(21899), key: "_typeName", dataIndex: "_typeName", width: "11%", render },
                    { title: gt(21900), key: "_pos", dataIndex: "_pos", width: "11%", render },
                    { title: gt(21293), key: "_ref2", dataIndex: "_ref2", width: "11%", render },
                    { title: gt(21294), key: "_custName", dataIndex: "_custName", width: "16%", render },
                    { title: gt(21295), key: "_sum", dataIndex: "_sum", width: "11%", render: renderSum },
                    { title: "", width: "7%", render: renderDocView },
                ]}
                pagination={false}
            />))
        }

        let dataSource = this.state.viewPerBranch ?
            this.props.data[this.id].branchDataset.map(x => {
                return {
                    key: `s${x._sectionId}b${x._branchId}p${x._payId}`,
                    branch: x._branchName,
                    pay: x._payName,
                    sum: renderSum(x._sum),
                    count: x._count,
                    detail: getDetaild(x.detaild.map(y => { return { ...y, key: y._docNum } }))
                }
            })
            : this.props.data[this.id].dataset.map(x => {
                return {
                    key: `s${x._sectionId}p${x._payId}`,
                    branch: gt(21297),
                    pay: x._payName,
                    sum: renderSum(x._sum),
                    count: x._count,
                    detail: getDetaild(x.detaild.map(y => { return { ...y, key: y._docNum } }))
                }
            })

        dataSource = [
            ...dataSource,
            {
                key: 'sumRow',
                branch: "",
                pay: gt(21296),
                sum: renderSum(this.props.data[this.id].sumAll),
                count: this.props.data[this.id].countAll,
            }
        ]

        let centralButton = (<Button onClick={() => { this.setState({ viewPerBranch: !this.state.viewPerBranch }) }}>{gt(this.state.viewPerBranch ? 21301 : 21302)}</Button>)

        return (<div style={divStyle}>
            <Card title={(<PageToolbar title={gt(21282)} showsearch={false} actionButtons={[]} />)}
                bordered={true} style={{ width: window.innerWidth < 600 ? '95%' : 600 }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }} >
                <Form.Item style={{ textAlign: 'center' }}>
                    <DashboardDateChecker
                        value={new Date(this.state._date)}
                        onChange={e => { this.setState({ _date: moment(e).format("YYYY-MM-DD") }) }}
                    />
                </Form.Item>
                <Form.Item style={{ textAlign: 'center' }}>
                    {gt(21283)}: {hourField('_fromHour')}  {gt(21284)}: {hourField('_toHour')} {gt(21285)}
                </Form.Item>
                <Form.Item label={gt(21286)} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                    <GenericSelectorBranches
                        {...this.props} multi
                        value={this.state._branchList ? this.state._branchList.split(",") : []}
                        onChange={e => { this.setState({ _branchList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
                <Form.Item>
                    <Checkbox checked={this.state._includePayItems == '1'} onChange={e => { this.setState({ _includePayItems: e.target.checked ? "1" : "0" }) }}>{gt(21287)}</Checkbox>
                </Form.Item>
                <Form.Item>

                    <Checkbox checked={this.state._includeCreditDocs == '1'} onChange={e => { this.setState({ _includeCreditDocs: e.target.checked ? "1" : "0" }) }}>{gt(21288)}</Checkbox>
                </Form.Item>


                <div style={{ textAlign: 'center', marginTop: 15 }}>
                    <Button type="primary" onClick={this.apiTable} loading={this.state.loading}>{gt(21289)}</Button>
                </div>
            </Card>

            <GenericModal
                visible={this.state.modalOpen}
                onCancel={() => { this.setState({ modalOpen: false }) }}
                title={gt(21282)}
                width={800}
            >
                <ResponsiveTable
                    tableOnly
                    dataSource={dataSource}
                    columns={[
                        { title: centralButton, key: "branch", dataIndex: "branch", width: "25%", render: renderPrimary },
                        { title: gt(21298), key: "pay", dataIndex: "pay", width: "25%", render: renderPrimary },
                        { title: gt(21299), key: "sum", dataIndex: "sum", width: "25%", render: renderPrimary },
                        { title: gt(21300), key: "count", dataIndex: "count", width: "15%", render: renderPrimary },
                        { width: "10%", render: renderDetail },
                    ]}
                    pagination={{ pageSize: 10 }}
                // expandedRowRender={r => r.detail}
                />
            </GenericModal>
            <GenericModal
                visible={this.state.modalDetail != null}
                onCancel={() => { this.setState({ modalDetail: null }) }}
                title={gt(21898) + this.state.modalDetail?.pay}
                width={1200}
            >
                {this.state.modalDetail?.detail}
            </GenericModal>

        </div>)
    }

}

export default DynamicReceiptDisplay;